export default {
  title: {
    fontFamily: 'Amariya, serif',
    letterSpacing: 0,
    marginBlockEnd: 0
  },
  preTitle: {
    fontFamily: 'Amariya, serif',
    letterSpacing: 0,
    margin: '0 0 18px'
  }
}
